module.exports = __webpack_public_path__ + "img/safecharge.e0742a72.svg";